"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftExtend = require("draft-extend");

var _constants = require("composer-plugins/lib/constants");

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _transformPropertiesForQuestions = _interopRequireDefault(require("composer-plugins/utils/transformPropertiesForQuestions"));

var _EditorQuestionBlock = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/entityComponents/EditorQuestionBlock"));

var _ToolbarButton = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/ToolbarButton"));

var BLOCK_TYPE = 'atomic';
var DISPLAY_NAME = 'QuestionAndAnswer';
var ENTITY_KEY = _constants.ENTITY_TYPES.questionAndAnswer;

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$props = options.props,
      properties = _options$props.properties,
      saveQuestion = _options$props.saveQuestion,
      questionsMap = _options$props.questionsMap,
      getInsertQuestionAndAnswerEnabled = _options$props.getInsertQuestionAndAnswerEnabled;
  var transformedProperties = (0, _transformPropertiesForQuestions.default)(properties);

  var blockRendererFn = function blockRendererFn(_ref) {
    var props = _ref.props;
    return function (currentBlock) {
      if (!(0, _draftHelpers.isCorrectBlockTypeAndSize)(currentBlock, BLOCK_TYPE)) {
        return undefined;
      }

      var entity = (0, _draftHelpers.getDefaultEntity)(currentBlock, props.getEditorState().getCurrentContent().getEntity);

      if (entity && entity.getType() === ENTITY_KEY) {
        return {
          component: _EditorQuestionBlock.default,
          editable: false,
          props: {
            saveQuestion: saveQuestion,
            questionsMap: questionsMap,
            properties: transformedProperties,
            getInsertQuestionAndAnswerEnabled: getInsertQuestionAndAnswerEnabled
          }
        };
      }

      return undefined;
    };
  };

  return (0, _draftExtend.createPlugin)({
    displayName: DISPLAY_NAME,
    buttons: (0, _ToolbarButton.default)(Object.assign({}, options, {
      properties: transformedProperties,
      saveQuestion: saveQuestion
    })),
    blockRendererFn: blockRendererFn(options)
  });
};

exports.default = _default;
module.exports = exports.default;